// src/services/CountryService.js
import api from "./api";

export function getCourseTypes(page = 1, limit = 10) {
    return api.get(
        `/coursetype?page=${page}&limit=${limit}&list=all`
    );
}
